import './styles/index.scss';

import { Grid } from '@mui/material';
import { EntitlementGroupInterface } from '@thro-types/access-handler';

import { Formik } from 'formik';
import omitDeep from 'omit-deep-lodash';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { useEntitlementGroupMutation } from 'api/hooks/accessHandler';
import MultistepForm from 'app/components/MultistepForm';
import { actions as AlertActions } from 'app/containers/Dashboard/Alert/slice';
import { translations } from 'locales/i18n';
import { Faculty } from 'types/AppTypes';
import { validateForm } from 'utils/FormErrorHelper';

import { EntitlementGroupFormGeneral } from './components/entitlement-group.form.general';
import { entitlementGroupValidation, useEntitlementGroupInitialValues } from './validation';

interface Props {
  closeHandler: () => void;
  setDisabledCancel?: Dispatch<SetStateAction<boolean>>;
  faculties: Faculty[];
  entitlementGroup: EntitlementGroupInterface | undefined;
}

export function EntitlementGroupModal(props: Props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { create, update } = useEntitlementGroupMutation();

  const handleSaveClick = async values => {
    if (create.isPending || update.isPending) {
      return;
    }
    if (props.setDisabledCancel) {
      props.setDisabledCancel(true);
    }
    const omitFields = ['id'] as const;
    let saveBody = {
      ...omitDeep(values, omitFields)
    };

    if (values.id) {
      // * UPDATE Entitlement-Group
      try {
        await update.mutateAsync({ id: values.id, data: saveBody });
        dispatch(
          AlertActions.success(t(translations.pages.entitlementGroups.alerts.saveSuccess()))
        );
        props.closeHandler();
      } catch (err) {
        dispatch(AlertActions.error(t(translations.pages.entitlementGroups.alerts.saveFailed())));
      }
    } else {
      // * CREATE EntitlementGroup
      try {
        await create.mutateAsync(saveBody);
        dispatch(
          AlertActions.success(t(translations.pages.entitlementGroups.alerts.saveSuccess()))
        );
        props.closeHandler();
      } catch (err) {
        dispatch(AlertActions.error(t(translations.pages.entitlementGroups.alerts.saveFailed())));
      }
    }
    if (props.setDisabledCancel) {
      props.setDisabledCancel(false);
    }
  };

  const steps = ['EntitlementGroup'];

  const CourseModalStep = ({ step }) => {
    switch (step) {
      case 0:
        return <EntitlementGroupFormGeneral faculties={props.faculties} />;
      default:
        return null;
    }
  };

  return (
    <Grid item className="entitlementGroupForm">
      <Formik
        // isInitialValid={!!props.entitlementGroup}
        initialValues={useEntitlementGroupInitialValues(props)}
        onSubmit={values => {
          handleSaveClick(values);
        }}
        validationSchema={entitlementGroupValidation(t)}
        validate={values => {
          return validateForm(values, entitlementGroupValidation(t), dispatch);
        }}
      >
        <MultistepForm
          submitting={create.isPending || update.isPending}
          steps={steps}
          onCancel={props.closeHandler}
          hideStepper
        >
          {activeStep => (
            <Grid container>
              <CourseModalStep step={activeStep} />
            </Grid>
          )}
        </MultistepForm>
      </Formik>
    </Grid>
  );
}
